<template>
  <div>
    <b-modal
      id="PTVHistoryModal"
      size="xl"
      @show="getHistory()"
    >
      <!-- Modal Title -->
      <template #modal-header>
        <div class="d-flex align-items-center justify-content-between w-100">
          <h5 class="mb-0 font-weight-semibold text-white">Interface Release History</h5>
        </div>
      </template>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-button class="close-btn px-4 py-2" @click="closeModal()">Close</b-button>
        </b-row>
      </template>
      <!-- <vue-bootstrap4-table
        :rows="releaseRows"
        :columns="releaseColumns"
        :config="config"
        :classes="classes"
      >
      </vue-bootstrap4-table> -->
      <vue-good-table
        id="PTV-Releases"
        class="m-2"
        :rows="releaseRows"
        :columns="releaseColumns"
        :pagination-options="pagination" 
        styleClass="vgt-table striped max-height-60"
      >
        <template #table-row="props">
          <span v-if="props.column.field == 'release_date' && props.row.release_date != null" style="width: 50px;">
              {{ new Date(props.row.release_date).toLocaleDateString()  }}
          </span>
          <span v-else style="width: 50px;">
              {{ props.row[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </b-modal>
  </div>
</template>

<style src="./Data_Tools.css" scoped></style>

<style>
.max-height-60 {
  max-height: 60vh;
}

#PTV-Releases .vgt-table thead th {
  white-space: nowrap; /* Prevent header text from wrapping */
}
</style>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
export default {
  name: 'DT_ReleaseHistory',
  components: {
    VueBootstrap4Table
  },
  data() {
    return {
      releaseRows: [],
      classes: {
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      releaseColumns: [
        {
          label: 'Version',
          field: 'version',
          sortable: true
        },
        {
          label: 'Release Date',
          field: 'release_date',
          sortable: true
        },
        {
          label: 'Notes',
          field: 'notes',
          sortable: false
        }
      ],
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: '#4a4a4a',
        show_refresh_button: false,
        show_reset_button: false
      },
      pagination: {
        enabled: true,
        perPage: 10,
        perPageDropdownEnabled: false,
      },
      search: {
        enabled: true
      },
      company_id: null
    }
  },
  props: ['user'],
  methods: {
    closeModal() {
      this.$bvModal.hide('PTVHistoryModal')
    },
    getHistory() {
      if (sessionStorage.token) {
        if (this.user.org != '') {
          axios
          .get(
            process.env.API_LOCATION + '/api/release_notes/getReleaseHistory',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                company_id: this.getOrgID
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(content.errors)
            } else {
              this.releaseRows = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          console.log('No User Org Set')
        }
      } else {
        console.log('No User Token')
      }
    }
  },
  computed: {
    getOrgID() {
      switch (this.$route.name) {
        case 'TRT':
          return 12;
        case 'DDT':
          return 11;
      }
    }
  }
}
</script>
